module.exports = __webpack_public_path__ + "static/media/us.71719706.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/countriesFlags/us.svg
// module id = 1474
// module chunks = 0